import * as S from "./styles.ts";

interface ITabContentProps {
  children: any;
}

const TabContent = ({ children }: ITabContentProps) => {
  return <S.TabContentContainer>{children}</S.TabContentContainer>;
};

export default TabContent;
